import { InjectionToken } from '@angular/core';
import { BOMItem } from 'src/app/models';
import { PagedCollection } from 'src/app/state/paged-collection';

// Starts on page 1. The Akita version looked like it seeded from the URL, but computed
// `Number(observable)` — always NaN — so `startWith` fell through to 1 on every load, and
// it read the unprefixed `page` param, which this table never writes (it uses `mbom_page`).
// Deep links still work: UrlPagedTable reads the URL and calls setPage.
export const BOM_ITEM_PAGINATOR = new InjectionToken('BOM_ITEM_PAGINATOR', {
  factory: () => new PagedCollection<BOMItem>(),
  providedIn: 'root',
});
